export enum RbhRemoveReasonType {
  None = 0,
  Scheduled = 1,
  Unscheduled = 2,
  ServiceableReturn = 3,
  RejectedQuarantinedPart = 4,
  ShelfLifeExpiration = 5,
}

export const GetRbhRemoveReasonType = [
  // { Description: "None", Value: RemoveReasonType.None },
  { Description: "Scheduled", Value: RbhRemoveReasonType.Scheduled },
  { Description: "Unscheduled", Value: RbhRemoveReasonType.Unscheduled },
  { Description: "Serviceable Return", Value: RbhRemoveReasonType.ServiceableReturn },
  { Description: "Rejected/Quarantined Part", Value: RbhRemoveReasonType.RejectedQuarantinedPart },
  { Description: "Shelf Life Expiration", Value: RbhRemoveReasonType.ShelfLifeExpiration },
];
